<template>
    <div>
        <h1 class="fd-news-title">{{ title }}
<!--            <div class="fd-pmgg-tag-01 fd-tag-spaciel" v-if=" ejlb === '14'">{{gylb}}</div>-->
        </h1>
        <div class="fd-news-message">
            <p v-if="active ==='hsal' || active ==='lltt'">发布时间：{{ dateFormat(date, 'yyyy-MM-dd') }}</p>
            <p v-if="active ==='hsal' || active ==='lltt'">发布法院：{{ fy }}</p>
            <div class="fd-detail-cz">
                <div class="fd-font-cz">字号：
                    <span class="fd-large" @click="addFontSize"></span>
                    <span class="fd-narrow" @click="narFontSize"></span>
                </div>
                <div class="fd-print" @click="printPage">打印本页</div>
            </div>

        </div>
<!--      <div class="fd-kypm-xq-02" v-if="ejlb === '16'">-->
<!--        <h2 class="fd-title-01">基本信息</h2>-->
<!--        <div class="fd-cbxx-content">-->
<!--          <div class="fd-cbxx-list" v-for="(item, index) in jbxxContent" :key="`cbxx${index}`">-->
<!--            <span class="fd-cbxx-name">{{item.name}}：</span>-->
<!--            <span class="fd-cbxx-val" :title="item.value" v-text="item.value"></span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="fd-kypm-xq-02" v-if="ejlb === '0' || ejlb === '1' || ejlb === '2'">-->
<!--        <div class="zdxal">-->
<!--          <div class="fd-yz-body">-->
<!--            <h3 class="fd-yz-center" v-if="yz">要旨</h3>-->
<!--            <h4 class="fd-yz-content">{{yz}}</h4>-->
<!--          </div>-->
<!--          <div class="fd-cbxx-list" v-for="(item, index) in jbxxContent" :key="`cbxx${index}`">-->
<!--            <span class="fd-cbxx-name">{{item.name}}：</span>-->
<!--            <span class="fd-cbxx-val" :title="item.value" v-text="item.value||'-'"></span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <h2 class="fd-title-01 fd-mt12 fd-m0-70" v-if=" ejlb === '16'">详情</h2>-->
      <div class="fd-kypm-xq-02" :style="{'font-size':`${fontSize}px`}">
        <div id="nr" v-html="nr"></div>
      </div>


      <div v-if="xgfj.length">
        <div class="fd-xgfj-title">相关附件</div>
        <div class="fd-xgfj-list"
             v-for="(item, index) in xgfj"
             :key="`xgfj${index}`"
             @click="downloadFiles(item.url,item.name)"
             v-text="item.name"></div>
      </div>
    </div>

</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            uploadParams: {
                businessId: '',
                type: 3
            },
            yz: '',
            jbxxContent: [],
            cbxx:[],
            xgfj:[],
            bh: null,
            navList: [],
            title: '',
            date: '',
            fy: '',
            fontSize:18,
            nr: null,
            ejlb: null,
            active: ''
        };
    },
    created() {
        this.ejlb = this.$route.query.ejlb;
        this.active = this.$route.query.active;
        this.uploadParams.businessId = this.$route.query.bh;
        this.initData();
        this.initFiles();
    },
    methods: {
        initData() {
            this.bh = this.$route.query.bh;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.HsalDataile.replace('{id}', this.bh)
            }).then((res) => {
                this.dealData(res);
            });
        },
        addFontSize() {
            this.fontSize += 2;
        },
        narFontSize() {
            if (this.fontSize > 10) {
                this.fontSize -= 2;
            }
        },
        // 打印页面
        printPage() {
            // 调用打印功能
            window.print();
        },
        // 处理请求返回的数据
        dealData(res) {
            this.title = res.data.bt;
            this.date = res.data.fbsj;
            this.fy = res.data.fbdwTranslateText;
            this.gylb = res.data.gylbTranslateText;
            this.nr = res.data.nr;
            this.nr = this.nr.replace(/font-size/g, '');
            this.nr = this.nr.replace(/line-height/g, '');
            // 法律法规   域外法律
            if (res.data.ejlb === '10' || res.data.ejlb === '8') {
                // this.dealFlfg(res);
            }
            // 案例分析
            if (res.data.ejlb === '16') {
                this.dealAlfx(res);
            }
            // 指导性案例 公报案例  年度精选案例
            if (res.data.ejlb === '0' || res.data.ejlb === '1' || res.data.ejlb === '2') {
                this.dealZdxal(res);
            }
        },
        // 处理指导性案例 公报案例  年度精选案例
        dealZdxal(res) {
            this.jbxxContent = [];
            this.yz = res.data.alyz;
            const anjianleixing = {name:'案件类型', value: res.data.ajlxTranslateText};
            const anyou = {name:'案由', value: res.data.ay};
            const anhao = {name:'案号', value: res.data.ah};
            const shenlifayuan = {name:'审理法院', value: res.data.slfy};
            const shenlichengxu = {name:'审理程序', value: res.data.slcxTranslateText};
            if (res.data.cpsj) {
                const cpsj = res.data.cpsj.substring(0, 10);
                const caipanshijian = {name:'裁判时间', value: cpsj};
                this.jbxxContent.push(caipanshijian);
            }
            const anlilaiyuan = {name:'来源', value: res.data.ajly};
            this.jbxxContent.push(anjianleixing);
            this.jbxxContent.push(anyou);
            this.jbxxContent.push(anhao);
            this.jbxxContent.push(shenlifayuan);
            this.jbxxContent.push(shenlichengxu);
            this.jbxxContent.push(anlilaiyuan);
        },
        // 处理案例分析的数据
        dealAlfx(res) {
            this.jbxxContent = [];
            const anjianleixing = {name:'案件类型', value: res.data.ajlxTranslateText};
            const anhao = {name:'案号', value: res.data.ah};
            const zhongcaijigou = {name:'仲裁机构', value: res.data.zcjg};
            const zongcairiqi = {name:'仲裁日期', value: res.data.zcrq};
            this.jbxxContent.push(anjianleixing);
            this.jbxxContent.push(anhao);
            this.jbxxContent.push(zhongcaijigou);
            this.jbxxContent.push(zongcairiqi);
        },
        // 处理法律法规   域外法律的数据
        dealFlfg(res) {
            this.jbxxContent = [];
            // const faluweijie = {name:'法律位阶', value: res.data.flwjTranslateText};
            // const gongbujiguan = {name:'公布机关', value: res.data.gbjg};
            // const youxiaoxin = {name:'有效性', value: res.data.yxxTranslateText};
            const gongburiqi = {name:'公布日期', value: res.data.gbrq};
            // this.jbxxContent.push(faluweijie);
            // this.jbxxContent.push(gongbujiguan);
            // this.jbxxContent.push(youxiaoxin);
            this.jbxxContent.push(gongburiqi);
        },
        downloadFiles(bh, name) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.downloadFile.replace('{id}', bh),
                contentType: 'application/json;charset=utf-8',
                responseType: 'blob'
            }).then((res) => {
                const binaryData = [];
                const template = res.data;
                binaryData.push(template);
                const blob = new Blob(binaryData);
                // 非IE下载
                if ('download' in document.createElement('a')) {
                    const elink = document.createElement('a');
                    elink.download = name;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, name);
                }
            });
        },
        initFiles() {
            if (this.$route.query.active === 'sptb') {
                this.uploadParams.type = 5;
            }
            if (this.$route.query.active === 'flzy') {
                this.uploadParams.type = 4;
            }
            if (this.$route.query.active === 'ywsf') {
                this.uploadParams.type = 6;
            }
            if (this.$route.query.active === 'hszc') {
                this.uploadParams.type = 2;
            }
            if (this.$route.query.active === 'hsal') {
                this.uploadParams.type = 1;
            }
            this.xgfj = [];
            const url = window.fdConfig.url.common.getFile;
            window.fdGlobal.ajax({
                url: url,
                methods: window.fdConfig.methodGet,
                params: this.uploadParams
            }).then((res) => {
                if (res.data.length) {
                    res.data.forEach(e => {
                        const zc = {
                            name: e.wjmc,
                            url: e.bh
                        };
                        this.xgfj.push(zc);
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>

